/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Navigation.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var Icon_1 = require("./Icon");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-navigation");
exports.Navigation = function Navigation(_a) {
    var children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["children", "className"]);
    return (React.createElement("nav", tslib_1.__assign({ className: classnames(moduleClassName(), className) }, props), children));
};
exports.Navigation.propTypes = {
    className: PropTypes.string
};
exports.NavigationLink = function NavigationLink(_a) {
    var _b = _a.active, active = _b === void 0 ? false : _b, _c = _a.back, back = _c === void 0 ? false : _c, _d = _a.mobile, mobile = _d === void 0 ? false : _d, _e = _a.chevron, chevron = _e === void 0 ? false : _e, icon = _a.icon, children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["active", "back", "mobile", "chevron", "icon", "children", "className"]);
    var child = React.Children.only(children);
    return React.cloneElement(child, tslib_1.__assign({ className: classnames(moduleClassName("link"), active && moduleClassName("link-isActive"), mobile && moduleClassName("link-isMobileLink"), back && moduleClassName("link-isBackLink"), child.props.className, className) }, props), [
        icon && (React.createElement(Icon_1.Icon, { key: "icon", className: classnames(moduleClassName("link-icon")), type: icon })),
        child.props.children,
        chevron && (React.createElement(Icon_1.Icon, { key: "linkChevron", className: classnames(moduleClassName("link-chevron")), type: "chevron-right-small" }))
    ]);
};
exports.NavigationLink.propTypes = {
    active: PropTypes.bool,
    mobile: PropTypes.bool,
    back: PropTypes.bool,
    chevron: PropTypes.bool,
    icon: PropTypes.oneOf(Icon_1.IconTypesArray),
    className: PropTypes.string
};
exports.NavigationSeparator = function NavigationSeparator(_a) {
    var className = _a.className, marginless = _a.marginless, props = tslib_1.__rest(_a, ["className", "marginless"]);
    return (React.createElement("hr", tslib_1.__assign({ className: classnames(moduleClassName("separator"), marginless && moduleClassName("separator-isMarginless"), className) }, props)));
};
exports.NavigationSeparator.propTypes = {
    className: PropTypes.string,
    marginless: PropTypes.bool
};